<template>
  <div
    class="radio-wrap"
    @keydown.enter.prevent="onChange"
  >
    <label>
      <input
        type="radio"
        :name="name"
        :value="value"
        :checked="isChecked"
      >
      <span @click="onChange">{{ label }}</span>
    </label>
  </div>
</template>

<script>
  /**
   * Exported events
   */

  export default {
    props: {
      name: {
        type: String,
        required: false,
        default: ''
      },
      label: {
        type: String,
        required: true
      },
      isChecked: {
        type: Boolean,
        default: true
      },
      value: {
        type: String,
        required: true
      }
    },
    methods: {
      onChange () {
        this.$emit('change', this.value)
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import '~assets/styles/common.scss';

  .radio-wrap {
    display: inline-block;
    margin: 0 38px 10px 0;
    color: #ffffff;

    @include bp-mf-desktop {
      margin-right: 30px;
    }

    @include bp-tablet {
      margin-right: 30px;
    }

    @include bp-mobile {
      float: left;
      margin: 0;
      width: 50%;
    }

    label {
      line-height: 24px;
      cursor: pointer;

      @include bp-mobile {
        display: block;
        line-height: 40px;
        text-align: center;
      }

      input[type="radio"] {
        display: none;

        &:checked + span {

          @include bp-mobile {
            background: #4a526c;
          }

          &:before {
            background: linear-gradient(to bottom, #bdc938 0%, #d0d842 100%);
            box-shadow: inset 0 0 3px #b4bd35;
          }
        }
      }

      span {

        @include bp-mobile {
          display: block;
          font-size: em(13);
          font-weight: 700;
        }

        &:before {
          content: '';
          position: relative;
          top: -1px;
          display: inline-block;
          margin-right: 8px;
          vertical-align: middle;
          width: 14px;
          height: 14px;
          border: 2px solid #ffffff;
          border-radius: 50%;

          @include bp-mobile {
            display: none;
          }
        }
      }
    }
  }
</style>
